<div class="pageheader">
    <div class="page-title">
        <h1>Run report</h1>
    </div>
</div>

<app-reports-run-report-configuration [reportId]="reportId" (resultOutput)="onResultOutputReceived($event)"></app-reports-run-report-configuration>
<app-reports-run-report-result [reportName]="$safeNavigationMigration(reportConfiguration?.Report.Name)" #resultPage></app-reports-run-report-result>
